module.exports = __webpack_public_path__ + "static/media/22-10.1b64d58e.mp3";